import React, { useEffect, useState } from "react";
import { graphql, StaticQuery } from "gatsby";
import { RichText as PrismicRichText } from "prismic-reactjs";

import { columnPush, serializer, linkResolver } from "utils";
import {
  Popup,
  FadeGroup,
  H1,
  PageHeader,
  Section,
  SEO,
  RichText,
  Button,
} from "components";

import ShowhomeCard from "./_showhomeCard";

function ShowhomesPage({ data, page, preview }) {
  const [showhomeType, setShowhomeType] = useState("");

  //popup
  // const [showPopup, setShowPopup] = useState(false);

  // let popupTimeout;

  // useEffect(() => {
  //   setTimeout(() => {
  //     setShowPopup(true);
  //   }, 2000);

  //   return function cleanup() {
  //     if (popupTimeout) {
  //       clearTimeout(popupTimeout);
  //     }
  //   };
  // }, []);

  // console.log(page.showhomes);

  const hasTownhomes = page.showhomes.some(
    (showhome) => showhome.showhome_type === "Townhome"
  );
  const hasLanedHomes = page.showhomes.some(
    (showhome) => showhome.showhome_type === "Laned Home"
  );
  const hasPairedHomes = page.showhomes.some(
    (showhome) => showhome.showhome_type === "Paired Home"
  );
  const hasBungalowHomes = page.showhomes.some(
    (showhome) => showhome.showhome_type === "Bungalow Home Options"
  );

  // console.log("hasPairedHomes", hasPairedHomes);

  return (
    <>
      <SEO
        image={page.seo_image && page.seo_image.url}
        title={page.seo_title && PrismicRichText.asText(page.seo_title)}
        description={
          page.seo_description && PrismicRichText.asText(page.seo_description)
        }
      />
      <PageHeader
        bg="brand.nickel"
        src={preview ? page.main_image && page.main_image.url : undefined}
        fluid={
          preview
            ? undefined
            : data.prismicShowhomes.data.main_image &&
              data.prismicShowhomes.data.main_image.fluid
        }
        alt={page.main_image && page.main_image.alt}
      />
      <Section pt={2} pb={2} bg={["brand.nickel", "bg.default"]}>
        <div
          css={`
            -ms-grid-column: 3;
            -ms-grid-column-span: 11;
            grid-column: 2 / 8;
            -ms-grid-row: 1;
            grid-row: 1;
            ${(props) => props.theme.mediaQueries.medium} {
              -ms-grid-column: 1;
              -ms-grid-column-span: 15;
              grid-column: 1 / 9;
            }
            ${(props) => props.theme.mediaQueries.small} {
              -ms-grid-column: 1;
              -ms-grid-column-span: 7;
              grid-column: 1 / 5;
            }
          `}
        >
          <div
            css={`
              position: relative;
              ${columnPush(1)};
              ${(props) => props.theme.mediaQueries.small} {
                padding-left: 0;
              }
            `}
          >
            <FadeGroup>
              <H1
                children={page.title && PrismicRichText.asText(page.title)}
                mb="0.5em"
                color={["text.reverse", "text.default"]}
              />
              <RichText
                children={
                  page.description &&
                  PrismicRichText.render(
                    page.description,
                    linkResolver,
                    serializer
                  )
                }
                color={["text.reverse", "text.default"]}
              />
            </FadeGroup>
          </div>
        </div>
      </Section>
      <Section
        pb={2}
        css={`
          ${(props) => props.theme.mediaQueries.small} {
            display: none;
          }
        `}
      >
        <hr
          css={`
            -ms-grid-column: 1;
            -ms-grid-column-span: 12;
            grid-column: 1 / 13;
            -ms-grid-row: 1;
            grid-row: 1;
            width: 100%;
            height: 1px;
            margin: 0;
            border: 0;
            background-color: ${(props) => props.theme.colors.bg.reverse};
            ${(props) => props.theme.mediaQueries.medium} {
              -ms-grid-column: 1;
              -ms-grid-column-span: 8;
              grid-column: 1 / 9;
            }
            ${(props) => props.theme.mediaQueries.small} {
              -ms-grid-column: 1;
              -ms-grid-column-span: 4;
              grid-column: 1 / 5;
            }
          `}
        />
      </Section>
      <Section
        pb={1}
        bg="bg.default"
        css={`
          ${(props) => props.theme.mediaQueries.small} {
            padding-top: 10vw;
            padding-bottom: 5vw;
          }
        `}
      >
        <div
          css={`
            -ms-grid-column: 1;
            -ms-grid-column-span: 23;
            grid-column: 1 / span 12;
            -ms-grid-row: 1;
            grid-row: 1;
            ${(props) => props.theme.mediaQueries.medium} {
              -ms-grid-column: 1;
              -ms-grid-column-span: 15;
              grid-column: 1 / 9;
            }
            ${(props) => props.theme.mediaQueries.small} {
              -ms-grid-column: 1;
              -ms-grid-column-span: 7;
              grid-column: 1 / 5;
            }
          `}
        >
          <div
            css={`
              padding-bottom: 5vw;
              text-align: center;
              > button {
                width: auto !important;
                width: initial !important;
                padding-top: 1em;
                padding-bottom: 1em;
                margin-bottom: 0.5em;
                &:not(:last-of-type) {
                  margin-right: 0.5em;
                }
              }
            `}
          >
            <Button
              children={`All showhomes`}
              className={true}
              onClick={() => {
                setShowhomeType("");
              }}
              className={showhomeType === "" ? "active" : "inactive"}
            />
            {hasTownhomes && (
              <Button
                children={`Townhomes`}
                onClick={() => {
                  setShowhomeType("Townhome");
                }}
                className={showhomeType === "Townhome" ? "active" : "inactive"}
              />
            )}
            {hasLanedHomes && (
              <Button
                children={`Laned Homes`}
                onClick={() => {
                  setShowhomeType("Laned Home");
                }}
                className={
                  showhomeType === "Laned Home" ? "active" : "inactive"
                }
              />
            )}
            {hasPairedHomes && (
              <Button
                children={`Paired Homes`}
                onClick={() => {
                  setShowhomeType("Paired Home");
                }}
                className={
                  showhomeType === "Paired Home" ? "active" : "inactive"
                }
              />
            )}
            {hasBungalowHomes && (
              <Button
                children={`Bungalow Home Options`}
                onClick={() => {
                  setShowhomeType("Bungalow Home Options");
                }}
                className={
                  showhomeType === "Bungalow Home Options"
                    ? "active"
                    : "inactive"
                }
              />
            )}
          </div>
        </div>
      </Section>
      {page.showhomes && (
        <Section pb={3} bg="bg.default">
          <div
            css={`
              -ms-grid-column: 1;
              -ms-grid-column-span: 23;
              grid-column: 1 / span 12;
              -ms-grid-row: 1;
              grid-row: 1;
              ${(props) => props.theme.mediaQueries.medium} {
                -ms-grid-column: 1;
                -ms-grid-column-span: 15;
                grid-column: 1 / 9;
              }
              ${(props) => props.theme.mediaQueries.small} {
                -ms-grid-column: 1;
                -ms-grid-column-span: 7;
                grid-column: 1 / 5;
              }
            `}
          >
            {page.showhomes.map((showhome, index) => (
              <ShowhomeCard
                show={
                  showhome.showhome_type === showhomeType || showhomeType === ""
                    ? true
                    : false
                }
                key={showhome.showhome_type + index}
                logoSrc={
                  preview ? showhome.logo && showhome.logo.url : undefined
                }
                logoFluid={
                  preview
                    ? undefined
                    : data.prismicShowhomes.data.showhomes[index].logo &&
                      data.prismicShowhomes.data.showhomes[index].logo.fluid
                }
                logoAlt={showhome.logo && showhome.logo.alt}
                src={preview ? showhome.image && showhome.image.url : undefined}
                fluid={
                  preview
                    ? undefined
                    : data.prismicShowhomes.data.showhomes[index].image &&
                      data.prismicShowhomes.data.showhomes[index].image.fluid
                }
                kitchen={
                  preview
                    ? undefined
                    : data.prismicShowhomes.data.showhomes[index].kitchen &&
                      data.prismicShowhomes.data.showhomes[index].kitchen.fluid
                }
                masterBedroom={
                  preview
                    ? undefined
                    : data.prismicShowhomes.data.showhomes[index].master_bedroom
                        .fluid
                }
                livingRoom={
                  preview
                    ? undefined
                    : data.prismicShowhomes.data.showhomes[index].living_room &&
                      data.prismicShowhomes.data.showhomes[index].living_room
                        .fluid
                }
                bathroom={
                  preview
                    ? undefined
                    : data.prismicShowhomes.data.showhomes[index].bathroom &&
                      data.prismicShowhomes.data.showhomes[index].bathroom.fluid
                }
                alt={showhome.image && showhome.image.alt}
                address={showhome.showhome_address}
                contact={showhome.builder_contact_name}
                phone={showhome.builder_contact_phone}
                website={
                  showhome.builder_website_link &&
                  showhome.builder_website_link.url
                }
                directionsLink={
                  showhome.directions_link && showhome.directions_link.url
                }
                email={showhome.builder_contact_email}
                home={showhome.showhome_name}
                category={showhome.showhome_type}
                // price={showhome.price}
                sqft={`1,290 – 2,100 sq ft`}
                key={"showhome" + index}
              />
            ))}
          </div>
        </Section>
      )}
      {/* {showPopup && <Popup />} */}
      {/* <Covid19 /> */}
    </>
  );
}

const ShowhomesPageWrapper = ({ preview }) => (
  <StaticQuery
    query={graphql`
      {
        prismicShowhomes {
          dataString
          data {
            main_image {
              fluid(maxWidth: 2048) {
                ...GatsbyPrismicImageFluid
              }
            }
            showhomes {
              image {
                fluid(maxWidth: 1600) {
                  ...GatsbyPrismicImageFluid
                }
              }
              kitchen {
                fluid(maxWidth: 1600) {
                  ...GatsbyPrismicImageFluid
                }
              }
              master_bedroom {
                fluid(maxWidth: 1600) {
                  ...GatsbyPrismicImageFluid
                }
              }
              bathroom {
                fluid(maxWidth: 1600) {
                  ...GatsbyPrismicImageFluid
                }
              }
              living_room {
                fluid(maxWidth: 1600) {
                  ...GatsbyPrismicImageFluid
                }
              }
              logo {
                fluid(maxWidth: 400) {
                  ...GatsbyPrismicImageFluid
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      let page = JSON.parse(data.prismicShowhomes.dataString);
      if (preview) {
        page = preview;
      }
      return <ShowhomesPage page={page} preview={preview} data={data} />;
    }}
  />
);

export default ShowhomesPageWrapper;
